<template>
   <div class="card is-smallshadow">
    <div class="card-body py-3">
      <h2 class="heading-small text-grey mb-2">
        {{ $t('customerAgreementsForm.marketingConsentCustomers') }}
      </h2>

      <validation-observer
        ref="customer-agreements-form"
        tag="form">
        <div class="form-group mb-2">
          <validation-provider
            rules="required|is-checked"
            name="accepted-regulations"
            v-slot="{ errors }">
            <f-checkbox
              :disabled="readonly"
              textLong
              v-model="data.accepted_terms_and_policy_privacy"
              :state="errors.length ? 'invalid' : null">
              <div class="checkbox-label">{{ $t('customerAgreementsForm.consent.termsAndPrivacy') }}</div>
              <div class="checkbox-text">
                {{ $t('customerAgreementsForm.consent.accept') }}
                  <a
                    :title="$t('customerAgreementsForm.consent.termsTitle')"
                    :href="siteDomain + pageLinks.regulations"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    class="text-medium-light">
                    {{ $t('customerAgreementsForm.consent.terms') }}
                  </a>
                  {{ $t('customerAgreementsForm.consent.and') }}
                  <a
                    :title="$t('customerAgreementsForm.consent.privacyPolicyTitle')"
                    :href="siteDomain + pageLinks.privacyPolicy"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    class="text-medium-light">
                    {{ $t('customerAgreementsForm.consent.privacyPolicy') }}
                  </a>.
              </div>
            </f-checkbox>
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
        <div class="form-group mb-2">
          <validation-provider
            name="contact-adviser-agreement"
            v-slot="{ errors }">
            <f-checkbox
              :disabled="readonly"
              textLong
              v-model="data.contact_adviser_agreement"
              :state="errors.length ? 'invalid' : null">
              <div class="checkbox-label">{{ $t('customerAgreementsForm.consent.contactWithExpert') }}</div>
              <div class="checkbox-text">
                {{ $t('customerAgreementsForm.informationSendEmail.offers') }}
                <a
                  :title="langId === 2 ? $t('general.finPl') : $t('general.finhub')"
                  :href="siteDomain"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  class="text-medium-light">
                  {{ getHostname(siteDomain) }}
                </a>.
              </div>
            </f-checkbox>
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
        <div class="form-group mb-2">
          <f-checkbox
            :disabled="readonly"
            textLong
            v-model="data.contact_finhub_agreement">
            <div class="checkbox-label">{{ $t('customerAgreementsForm.consent.marketing') }}</div>
            <div class="checkbox-text">
             {{ $t('customerAgreementsForm.informationSendEmail.serwis') }}
              <a
                :title="langId === 2 ? $t('general.finPl') : $t('general.finhub')"
                :href="siteDomain"
                target="_blank"
                rel="nofollow noopener noreferrer"
                class="text-medium-light">
                {{ getHostname(siteDomain) }}
              </a>.
            </div>
          </f-checkbox>
        </div>
      </validation-observer>
    </div>

    <div
      v-if="!readonly"
      class="card-footer pt-3 pb-4 text-right">
      <f-button
        theme="primary"
        big
        @click.prevent="validateForm">
        {{ $t('ui.save')}}
      </f-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import FormUtils from '@/utils/FormUtils.js';
import getPageLinks from '@/data/page-links';

export default {
  name: 'customer-agreements-form',
  props: {
    acceptedTermsAndPolicy: {
      type: [Boolean, Number],
      required: true
    },
    contactAdviserAgreement: {
      type: [Boolean, Number],
      required: true
    },
    contactFinhubAgreement: {
      type: [Boolean, Number],
      required: true
    },
    readonly: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    ...mapGetters({
      siteDomain: 'getSideDomain',
      langId: 'getUserLanguageId'
    })
  },
  data() {
    return {
      data: {
        accepted_terms_and_policy_privacy: false,
        contact_adviser_agreement: false,
        contact_finhub_agreement: false
      },
      pageLinks: getPageLinks()
    }
  },
  mounted() {
    Vue.set(this.data, 'accepted_terms_and_policy_privacy', !!this.acceptedTermsAndPolicy);
    Vue.set(this.data, 'contact_adviser_agreement', !!this.contactAdviserAgreement);
    Vue.set(this.data, 'contact_finhub_agreement', !!this.contactFinhubAgreement);
  },
  methods: {
    submitForm () {
      let formDataToSend = {
        accepted_terms_and_policy_privacy: this.data.accepted_terms_and_policy_privacy ? 1 : 0,
        contact_adviser_agreement: this.data.contact_adviser_agreement ? 1 : 0,
        contact_finhub_agreement: this.data.contact_finhub_agreement ? 1 : 0
      };

      let endpointUrl = '/api/customer/customer/update-acceptance';

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: this.$t('ui.savedChanges'),
        successText: this.$t('customerAgreementsForm.yourProfileHasBeenUpdate'),
        errorTitle: this.$t('ui.errorOccurred'),
        errorText: this.$t('customerAgreementsForm.updateProfileError'),
        successAction: () => {
          this.$bus.$emit('customer-settings-reload');
        }
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['customer-agreements-form'], this.submitForm);
    },
    getHostname (url) {
      return new URL(url).hostname;
    }
  }
}
</script>
